<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [title]="'Event Engagement Rate'"
  [chartType]="'line'"
  [options]="options"
  [translateLabels]="true"
></app-bar-chart>
